import { useIsEmployeeProfileAccessible } from 'domain/shared/employee';
import TimelineRecordAuthor, { TimelineRecordAuthorProps } from './TimelineRecordAuthor';

const TimelineRecordAuthorWithAccessCheck = ({ id, ...props }: Omit<TimelineRecordAuthorProps, 'isLink'>) => {
  const isProfileAccessible = useIsEmployeeProfileAccessible(id);

  return <TimelineRecordAuthor id={id} isLink={isProfileAccessible} {...props} />;
};

export default TimelineRecordAuthorWithAccessCheck;
